import React, { Component } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import Home from './components/Home';

class App extends Component {
    render() {
        return (
            <HashRouter>
                <Switch>
                    <Route exact path='/' >
                        <Home />
                    </Route>
                </Switch>
            </HashRouter>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js